import { ACTION_SUBJECT_PREFIX } from '../../constants/analytics';
import { type FireAnalyticsEvent } from '../../types';
import { type CommonAttributes, type NonPrivacySafeAttributes } from './types';

/** button clicked searchPageRightPanelAppFilterShowMore */
export const onAppFilterShowMoreClicked = ({
	commonAttributes,
	nonPrivacySafeAttributes,
	isConnected,
	section,
}: {
	commonAttributes: CommonAttributes;
	nonPrivacySafeAttributes: NonPrivacySafeAttributes;
	isConnected: boolean;
	section: 'filterResults' | 'connectApps';
}): FireAnalyticsEvent => ({
	eventType: 'ui',
	actionSubject: 'button',
	actionSubjectId: `${ACTION_SUBJECT_PREFIX}RightPanelAppFilterShowMore`,
	action: 'clicked',
	attributes: {
		additionalAttributes: {
			isConnected,
			section,
		},
		commonAttributes,
	},
	nonPrivacySafeAttributes,
});
